import React from 'react'
import { Stack, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'

interface LimitHighConsumptionCasesOverviewProps {
  data: any
}

export default function LimitHighConsumptionCasesOverview({ data }: LimitHighConsumptionCasesOverviewProps) {
  const theme = useTheme()
  const cases = data?.limited_case_info ?? []
  const totalCases = cases.length

  const getLatestFilingTime = () => {
    if (cases.length === 0) return '—'
    const times = cases
      .map((item: any) => item?.caseRegTime)
      .filter((time: string) => time && time !== '')
      .sort((a: string, b: string) => b.localeCompare(a))
    return times.length > 0 ? times[0] : '—'
  }

  const getCourtCount = () => {
    if (cases.length === 0) return 0
    const courts = new Set(cases.map((item: any) => item?.courtName).filter((name: string) => name && name !== ''))
    return courts.size
  }

  const latestFilingTime = getLatestFilingTime()
  const courtCount = getCourtCount()

  return (
    <div className="mt-2">
      <Stack gap="md">
        <div className="flex flex-col gap-2">
          <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
            限高案件概览
          </Text>
          <Text size="xs" className="text-gray-500">
            汇总限制高消费案件的整体情况,包括案件数量、立案时间及涉及法院。
          </Text>
        </div>
        <div className="grid gap-3 md:grid-cols-3">
          <SummaryItem label="案件总数" value={`${totalCases} 件`} subtitle="限制高消费案件" />
          <SummaryItem label="最近立案时间" value={latestFilingTime} subtitle="最新案件立案日期" />
          <SummaryItem
            label="涉及法院数量"
            value={`${courtCount} 家`}
            subtitle={courtCount > 0 ? '去重统计' : '无法院记录'}
          />
        </div>
      </Stack>
    </div>
  )
}

interface SummaryItemProps {
  label: string
  value: string
  subtitle?: string
}

function SummaryItem({ label, value, subtitle }: SummaryItemProps) {
  const theme = useTheme()

  return (
    <div
      className="rounded-lg border px-4 py-3"
      style={{ borderColor: theme.surfaceBorderColor, backgroundColor: theme.surfaceColor }}
    >
      <Text size="xs" className="text-gray-500">
        {label}
      </Text>
      <Text size="sm" fw={600} style={{ marginTop: '6px', color: theme.primaryColor }}>
        {value}
      </Text>
      {subtitle && (
        <Text size="xs" className="text-gray-400" style={{ marginTop: '4px' }}>
          {subtitle}
        </Text>
      )}
    </div>
  )
}
